import { Action } from './Action';
export class AgentAction extends Action {
    static $inject = ['init'];
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
